module.exports = __webpack_public_path__ + "static/media/Sidra Ijaz.8ab45b77.jpg";